class SoftspaceSetup extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.button = this.querySelector('[data-add]');
    this.status = this.querySelector('[data-status]');
    this.addEventListener('change', () => this.update());
    this.addEventListener('input', () => this.updateTotal());
    this.button.addEventListener('click', () => this.addItems());
    this.update();
  }
  rows() { return [...this.querySelectorAll('[data-setup-row]')]; }
  update() {
    for (const row of this.rows()) {
      const option = row.querySelector('select').selectedOptions[0];
      const input = row.querySelector('[data-quantity]');
      input.min = option.dataset.min;
      input.step = option.dataset.step;
      if (option.dataset.max !== undefined) input.max = option.dataset.max;
      else input.removeAttribute('max');
      const min = Number(input.min), step = Number(input.step);
      let value = Math.max(min, Number(input.value) || min);
      if (input.max !== '') value = Math.min(Number(input.max), value);
      input.value = String(Math.max(min, min + Math.floor((value - min) / step) * step));
    }
    this.updateTotal();
  }
  updateTotal() {
    let total = 0, selected = 0, units = 0;
    const lines = [];
    for (const row of this.rows()) {
      if (!row.querySelector('[data-include]').checked) continue;
      const quantity = Math.max(0,Math.trunc(Number(row.querySelector('[data-quantity]').value) || 0));
      const price = Number(row.querySelector('select').selectedOptions[0].dataset.price);
      const line = price * quantity;
      total += line;
      units += quantity;
      lines.push({price,quantity});
      selected++;
    }
    const money = value => new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(value / 100);
    const savings = units >= 2 ? lines.reduce((sum,line) => sum + Math.floor(line.price / 10) * line.quantity,0) : 0;
    this.querySelector('[data-regular]').textContent = money(total);
    this.querySelector('[data-savings]').textContent = money(savings);
    this.querySelector('[data-rate]').textContent = savings ? '(10%)' : '';
    this.querySelector('[data-total]').textContent = money(total - savings);
    this.querySelector('[data-eligibility]').textContent = units >= 2 ? 'Your selection qualifies for the automatic 10% offer.' : 'Choose two or more eligible items to save 10%.';
    this.button.disabled = !selected || this.busy;
  }
  async addItems() {
    if (this.busy || window.softspaceSetupBusy) return;
    const rows = this.rows().filter(row => row.querySelector('[data-include]').checked);
    if (!rows.length) return;
    for (const row of rows) if (!row.querySelector('[data-quantity]').reportValidity()) return;
    this.busy = window.softspaceSetupBusy = true;
    this.button.disabled = true;
    this.setAttribute('aria-busy','true');
    this.status.textContent = 'Checking availability…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('Could not check your cart. Please try again.');
      const cart = await cartResponse.json();
      const items = rows.map(row => {
        const option = row.querySelector('select').selectedOptions[0];
        const quantity = Number(row.querySelector('[data-quantity]').value);
        const existing = cart.items.filter(item => String(item.variant_id) === option.value).reduce((sum,item) => sum + item.quantity,0);
        if (option.dataset.max !== undefined && existing + quantity > Number(option.dataset.max)) {
          throw new Error('The selected quantity exceeds current availability or the purchase limit, including items already in your cart. Reduce the quantity or choose another option.');
        }
        return {id:Number(option.value),quantity};
      });
      this.status.textContent = 'Adding selected items…';
      const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok) throw new Error((result.description || 'Some items could not be added.') + ' Review your cart before retrying.');
      this.status.textContent = 'Added. Opening your cart…';
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.status.textContent = error.message || 'Could not update your cart. Review your cart before retrying.';
      this.busy = window.softspaceSetupBusy = false;
      this.removeAttribute('aria-busy');
      this.updateTotal();
    }
  }
}
if (!customElements.get('softspace-setup')) customElements.define('softspace-setup', SoftspaceSetup);
